/**
 * @description upp支付
 * @param {string} url 支付地址
 * @param {array} arr [encodeMsg, signMsg, merAppId, merId, local]
 */
export default function uppPay(url, arr) {
    if (arr === void 0) {
        arr = [];
    }
    var form = document.createElement('form');
    form.style.display = 'none';
    form.setAttribute('method', 'post');
    form.setAttribute('name', 'form1');
    form.setAttribute('id', 'form1');
    form.setAttribute('action', url);
    var str = ['encodeMsg', 'signMsg', 'merAppId', 'merId', 'locale'];
    arr.forEach(function (item, i) {
        var input = document.createElement('input');
        input.setAttribute('name', str[i]);
        input.setAttribute('value', item);
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/pay/uppPay.js
// module id = null
// module chunks = 